export default __webpack_public_path__ + "static/media/settings.9a401842.jpg";